import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Store } from '@ngxs/store';
import { getIconByExtension } from 'src/app/helper/iconHelper';
import { Attachment } from 'src/generated/swagger';

@Component({
   selector: 'samweb-attachment-item',
   templateUrl: './attachment-item.component.html',
   styleUrls: ['./attachment-item.component.scss'],
})
export class AttachmentItemComponent implements OnInit {
   @Input()
   public overlayIcon: IconDefinition;

   @Input()
   public attachment: Attachment;

   @Input()
   public messageId: string;

   @Output()
   public click = new EventEmitter<Attachment>();

   public fileIcon: IconDefinition;

   constructor(public store: Store) {}

   ngOnInit() {
      this.fileIcon = getIconByExtension(this.attachment.name);
   }

   onClick() {
      this.click.emit(this.attachment);
   }
}
